import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";
import { fetchSearchCount } from "../../src/utils/fetchSearchCount";

// Connects to data-controller="job-filter--sp-occupation-modal"
export default class extends Controller {
  static targets = ["modal", "checkbox", "form", "searchCount", "searchCountUnit", "submitButton"];

  declare modalTarget: HTMLElement;
  declare checkboxTargets: HTMLInputElement[];
  declare formTarget: HTMLFormElement;
  declare searchCountTarget: HTMLElement;
  declare searchCountUnitTarget: HTMLElement;
  declare submitButtonTarget: HTMLButtonElement;

  modal: Modal;
  debounceTimeout = 0; // デバウンス管理用

  connect() {
    this.modal = new Modal(this.modalTarget);
  }

  openModal(): void {
    this.fetchModalSearchCountWithDebounce();
    this.modal.show();
  }

  closeModal(): void {
    this.modal.hide();
  }

  // リセットボタンの処理
  reset(): void {
    // すべてのチェックボックスの選択を解除
    this.checkboxTargets.forEach((checkbox) => {
      checkbox.checked = false;
    });

    this.fetchModalSearchCountWithDebounce();
  }

  // change イベント
  handleOccupationChange(_event: Event): void {
    this.fetchModalSearchCountWithDebounce();
  }

  // フォーム変更時の処理
  private fetchModalSearchCountWithDebounce() {
    clearTimeout(this.debounceTimeout);

    this.debounceTimeout = window.setTimeout(async () => {
      const count = await fetchSearchCount({ form: this.formTarget });
      this.updateModalSearchCount(Number(count));
      this.submitButtonTarget.disabled = Number(count) <= 0;
    }, 500);
  }

  // モーダル内の検索件数表示を更新する
  private updateModalSearchCount(count: number): void {
    if (count > 999) {
      this.searchCountTarget.textContent = "999";
      this.searchCountUnitTarget.textContent = "件以上";
    } else {
      this.searchCountTarget.textContent = count.toString();
      this.searchCountUnitTarget.textContent = "件";
    }
  }
}
